module.exports = __webpack_public_path__ + "media/SOS.4854eaf8.mp3";